import { Badge, Icon, IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAppSelector } from "~/hooks/reduxHooks";
import useAvailabilityPendingCount from "~/hooks/useAvailabilityPendingCount";

const ActionMenu = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const actionLinks = useAppSelector((state) => state.layout.actionLinks);

	// Get pending counts for badge display (only when on availability pages)
	const { count: pendingCount } = useAvailabilityPendingCount();
	const isAvailabilityPage = location.pathname.startsWith("/availability");
	const showBadge = isAvailabilityPage && pendingCount > 0;

	const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState<null | HTMLElement>(null);

	const handleMenuItemClick = (path: string) => {
		navigate(path);
		setActionMenuAnchorEl(null);
	};

	const handleActionMenuClose = () => {
		setActionMenuAnchorEl(null);
	};

	if (!actionLinks || actionLinks.length === 0) {
		return null;
	}

	return (
		<>
			<IconButton
				color="inherit"
				onClick={(event) => {
					setActionMenuAnchorEl(event.target as HTMLElement);
				}}
			>
				{showBadge ? (
					<Badge badgeContent=" " color="error" variant="dot">
						<Icon>arrow_drop_down_circle</Icon>
					</Badge>
				) : (
					<Icon>arrow_drop_down_circle</Icon>
				)}
			</IconButton>
			<Menu
				anchorEl={actionMenuAnchorEl}
				anchorOrigin={{
					horizontal: "right",
					vertical: "bottom"
				}}
				id="basic-menu"
				onClose={handleActionMenuClose}
				open={Boolean(actionMenuAnchorEl)}
				slotProps={{
					list: {
						"aria-labelledby": "action-button"
					}
				}}
				transformOrigin={{
					horizontal: "right",
					vertical: "top"
				}}
			>
				{actionLinks.map((item, i) => {
					const isReviewAction = item.key === "review" || item.label?.toLowerCase().includes("review");
					return (
						<MenuItem key={i} onClick={() => handleMenuItemClick(item.link || "")} sx={{ minWidth: "300px" }}>
							<ListItemIcon>
								<Icon>{item.iconName}</Icon>
							</ListItemIcon>{" "}
							{item.label}
							{isReviewAction && showBadge && (
								<Badge badgeContent={pendingCount} color="error" sx={{ ml: "auto", mr: 1 }} />
							)}
						</MenuItem>
					);
				})}
			</Menu>
		</>
	);
};

export default ActionMenu;
